<div class="modal-header">
    <div class="modal-title">Order 3rd Party Report</div>
    <button type="button" class="close" id="order-confirm-modal-close" aria-label="Close" (click)="decline()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <p class="font-size-12">
        <strong>Disclaimer:</strong> You are now leaving Valzy, LLC’s (“IV”) website and are going to
        <a href="http://www.reliantvalue.com" target="_blank" rel="noopener" class="color--blue">www.reliantvalue.com</a>,
        a website operated by Reliant Business Valuation, LLC (‘RBV’) that is not operated by IV. We are not responsible
        for the content or availability of linked sites.
    </p>

    <p class="font-size-12">
        Also, please be aware that the security and privacy policies on <a href="http://www.reliantvalue.com" target="_blank" rel="noopener"
            class="color--blue">www.reliantvalue.com</a> may be different than Valzy’s
        policies, so please read third party privacy and security policies closely. If you have any questions or
        concerns about the products and services offered on linked third party websites, please contact the third party
        directly at <a class="color--blue" href="http://www.reliantvalue.com/contact-us/"
            target="_blank" rel="noopener">http://www.reliantvalue.com/contact-us/</a>.
    </p>

    <p class="mt-4">
        By clicking on the <strong>Continue</strong> button below, You acknowledge the previous statement.
        You also agree and allow Valzy to send RBV the Report that Report Generator compiled on <strong>{{businessName}}</strong>,
        along with Report Generator’s name, bank name and email address.<br /><br />
        If you want to remain at this site, select the <strong>Cancel</strong> button.
    </p>
</div>

<div class="modal-footer">
    <button type="button" id="order-confirm-modal-cancel" class="button secondary__button large__button" (click)="decline()">Cancel</button>
    <button type="button" id="order-confirm-modal-continue" class="button primary__button large__button" (click)="confirm()">Continue</button>
</div>